import RecurringTasksList from './RecurringTasksList';

export default RecurringTasksList;
